import React from 'react';
import { HalfDoughnutChart } from '../charts/HalfDoughnutChart';
import { Information } from '../Information';
import { t } from '../../i18n';

const Completed = ({ value, total }: Props) => {
  const mainColor = '#00DE91';
  const restColor = '#BCFAD8';
  const percentage = value !== 0 && total !== 0 ? Math.round((value / total) * 100) : 0;
  const rest = 100 - percentage;
  const datasets = [{ data: [ { value: percentage, label: percentage + '%' }, { value: rest, label: rest + '%' } ], backgroundColor: [ mainColor, restColor ]}];
  const labels = ['V', 'R'];
  return (
    <div className="d-flex">
      <div className="d-flex flex-column h-100">
        <div className="d-flex align-items-center">
          <Information id="fully" content={<small className="text-gray-09 me-2">{t('mediaPlayback.fully')}</small>} />  
          <Information id="fully" showMore={true} />
        </div>
        <div className="flex-grow-1" style={{ width: 65 }}>
          <HalfDoughnutChart datasets={datasets} labels={labels} />
        </div>
      </div>
      <div className="ms-3">
        <h1 className="mb-0 gray-12">{value}</h1>
        <div className="text-gray-09 fs-7">{t('common.ofTotal', { percentage })}</div>
      </div>
    </div>
  );
}

interface Props {
  value: number,
  total: number
}

export { Completed };